<script lang="ts">
  import Router from "svelte-spa-router";
  import { push } from "svelte-spa-router";
  import Login from "./routes/Login.svelte";
  import Map from "./routes/Map.svelte";
  import Reset from "./routes/Reset.svelte";
  import Setup from "./routes/Setup.svelte";
  import Signup from "./routes/Signup.svelte";
  import AdminStatus from "./routes/AdminStatus.svelte";
  import AdminUsers from "./routes/AdminUsers.svelte";
  import AdminInvites from "./routes/AdminInvites.svelte";
  import AdminDashboards from "./routes/AdminDashboards.svelte";
  import AdminDeliveries from "./routes/AdminDeliveries.svelte";
  import AdminBallots from "./routes/AdminBallots.svelte";
  import WalkList from "./routes/WalkList.svelte";
  import Results from "./routes/Results.svelte";
  import AdminRetrospective from "./routes/AdminRetrospective.svelte";
  import CongratsModal from "./components/CongratsModal.svelte";
  import Toast from "./components/Toast.svelte";
  import { currentUser, initAuth } from "./lib/stores/auth";
  import { onMount } from "svelte";

  const routes = {
    "/login": Login,
    "/setup": Setup,
    "/signup/:token": Signup,
    "/reset/:token": Reset,
    "/map": Map,
    "/admin/status": AdminStatus,
    "/admin/users": AdminUsers,
    "/admin/invites": AdminInvites,
    "/admin/dashboards": AdminDashboards,
    "/admin/deliveries": AdminDeliveries,
    "/admin/ballots": AdminBallots,
    "/walk-list": WalkList,
    "/results": Results,
    "/admin/retrospective": AdminRetrospective,
    "*": Login,
  };

  onMount(async () => {
    await initAuth();
    const hash = window.location.hash;
    const onExplicitRoute = hash && hash !== "#" && hash !== "#/";
    if (onExplicitRoute) return;
    if ($currentUser) {
      push("/map");
    } else {
      push("/login");
    }
  });
</script>

<Router {routes} />
<Toast />
<CongratsModal />
